var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"workplatform-title"},[_vm._v("费用汇总")]),_c('i-table',{attrs:{"stripe":"","data":_vm.products,"columns":_vm.productColumns,"summary-method":_vm.handleSummary,"show-summary":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }